import { render, staticRenderFns } from "./button-default.vue?vue&type=template&id=6f2be661&scoped=true&"
import script from "./button-default.vue?vue&type=script&lang=js&"
export * from "./button-default.vue?vue&type=script&lang=js&"
import style0 from "./button-default.vue?vue&type=style&index=0&id=6f2be661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2be661",
  null
  
)

export default component.exports